import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6

import '../style/app.css';
import Capcalera from './capcalera/capcalera';
import Peu from './peu/peu';

const entornDesenvolupament = 'development';

class App extends Component {

    /**
     * A l'entorn de desenvolupament no ens interessa que cada cop que es recarregui la pàgina ens demani confirmació
     * Donat que tenim el hot module replacement de webpack activat.
     ***/
    static esEntornDesenvolupament() {
        if (process && process.env && process.env.REACT_APP_ENVIROMENT) {
            return process.env.REACT_APP_ENVIROMENT === entornDesenvolupament;
        }

        return false;
    }

    static listenerBeforeUnload(event) {
        event.returnValue = 'Es recarregarà la pàgina principal i es perdran les dades introduïdes. Desitja continuar?.';
    }

    componentDidMount() {
        if (!App.esEntornDesenvolupament()) {
            window.addEventListener('beforeunload', App.listenerBeforeUnload);
        }
    }

    componentWillUnmount() {
        if (!App.esEntornDesenvolupament()) {
            window.removeEventListener('beforeunload', App.listenerBeforeUnload);
        }
    }

    render() {
        const urlActual = this.props.location ? this.props.location.pathname : '';
        return (
            <div className='app-grid'>
                <header>
                    <Capcalera urlActual={urlActual} />
                </header>
                <main>
                    {this.props.children}
                </main>
                <footer>
                    <Peu />
                </footer>
            </div>
        );
    }
}

App.propTypes = {
    children: PropTypes.element,
    location: PropTypes.object
};

export default App;



// WEBPACK FOOTER //
// ./src/components/app.js